// extracted by mini-css-extract-plugin
export default {"loader":"OI4TM","dot":"vWG7x","changeColor":"i0t2l"};